let screenWidth = window.matchMedia('(max-width: 1199px)');
let mobileNavContainer = document.querySelector('.mobileNavContainer');
let rightButtonsContainer = document.querySelector('.rightButtons');

let rightButtons = document.querySelectorAll('.rightButtons > *:not(#showSiteMenu)');
let theNavigation = document.querySelector('.mainNavigation');
let menuButton = document.querySelector('#showSiteMenu');

doNavigation(screenWidth);
screenWidth.addEventListener("change", (e) => {
	doNavigation(e)
});

function moveIntoMobile() {
	console.log('moveintomobile');
	console.log({
		mobileNavContainer,
		rightButtonsContainer,
		rightButtons,
		theNavigation,
		menuButton
	});

	mobileNavContainer.append(theNavigation);
	rightButtons.forEach(
		function (node) {
			console.log({node});
			mobileNavContainer.append(node);
		}
	);
}

function moveOutOfMobile() {
	console.log('moveoutofmobile');
	console.log({
		mobileNavContainer,
		rightButtonsContainer,
		rightButtons,
		theNavigation,
		menuButton
	});

	rightButtonsContainer.before(theNavigation);
	rightButtons.forEach(
		function (node) {
			rightButtonsContainer.append(node);
		}
	);
	rightButtonsContainer.append(menuButton);
}

function doNavigation(matchMedia) {
	if (matchMedia.matches) {
		moveIntoMobile();
	} else {
		moveOutOfMobile();
	}
}
